<h1 mat-dialog-title>{{ 'protocolEdit.dialog.signers.title' | translate }}</h1>
<form>

  <div mat-dialog-content [class]="getTheme()" style="overflow-y: hidden;">
    <div fxLayout="column">
      <div fxFlex="100">
        <div fxFlex="80" style="font-size: 18px; align-content: center;">
          <span>{{'signatureDocument.form.title' | translate}} #{{data.nDocument}}</span>
        </div>
        <div fxFlex="20">
          <div fxFlex>
            @if (showChangeLangIcon()) {
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'common.reportType.options.language.label' | translate }}</mat-label>
                <mat-select name="lang" [(ngModel)]="document.lang" [disabled]="inactiveSignature()"  [ngModelOptions]="{standalone: true}">
                  @for (item of langs; track item) {
                    <mat-option [value]="item.lang">
                      <mat-icon svgIcon="{{item.flag}}"></mat-icon>
                      {{item.fullLang}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
          </div>
        </div>
      </div>
      <div fxFlex="100">
        <div fxFlex="100" style="font-size: 15px;">
          <span>{{'signatureDocument.form.subtitle' | translate}}</span>
        </div>
      </div>
      <br>
        <div fxFlex="30">
          @if (!inactiveSignature()) {
            <button mat-raised-button color="primary" (click)="addSigners()" cdkFocusInitial>{{ 'button.addSigners'
            | translate }}</button>
          }
        </div>
      </div>
      <div fxLayout="column">
        <div fxFlex>
          <div cdkDropList [cdkDropListData]="signersDatasource" class="verification-drop-list"
            (cdkDropListDropped)="drop($event)" >
            @for (signer of signersDatasource; track trackBySigner(indexSigner, signer); let indexSigner = $index) {
              <div fxLayout="column"
                class="container-signer verification-drop-box" cdkDrag [cdkDragDisabled]="disabledSigned(signer)">
                @if (signer.idStatus != 4) {
                  <div fxFLex="100" fxLayout="row" class="container-signer-item"
                    [ngClass]="'color-signature ' + getCurrentUserSigner(signer)">
                    @if (!disabledSigned(signer)) {
                      <div fxFlex="5" cdkDragHandle fxLayout="row">
                        <span>
                          <mat-icon [id]="'idOrder'+indexSigner" class="move-drag-cursorr">reorder</mat-icon>
                        </span>
                      </div>
                    }
                    <div fxFlex="95" fxLayout="column">
                      <div fxLayout="row" fxFlex="100">
                        @if (!data.isManual) {
                          <div fxFlex="80">
                            <mat-form-field class="campoFormulario">
                              <mat-label>{{ 'common.reportType.options.reviewBy.label' | translate
                              }}</mat-label>
                              <input type="text" [id]="'fullName'+indexSigner"
                                [name]="'fullName'+indexSigner" aria-label="text" matInput
                                [(ngModel)]="signer.fullName" [disabled]="disabledSigned(signer)"
                                [matAutocomplete]="auto" [ngModelOptions]="{standalone: true}"
                                (keyup)="lookupUsers($event)">
                              <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete"
                                [displayWith]="displayFn"
                                (optionSelected)="onUserChange($event, indexSigner)">
                                @for (item of respDocsFiltered; track item; let index = $index) {
                                  <mat-option
                                    [value]="item" [disabled]="!disableUserSelected(item.username)">
                                    {{item.fullName}} ({{item.email}})
                                  </mat-option>
                                }
                              </mat-autocomplete>
                            </mat-form-field>
                          </div>
                          <div fxFlex="10">
                            <mat-checkbox [id]="'onlyCopy'+indexSigner" [name]="'onlyCopy'+indexSigner" [(ngModel)]="signer.onlyCopy"
                              [ngModelOptions]="{standalone: true}" [disabled]="disabledSigned(signer)">
                              {{ 'protocolEdit.dialog.signers.onlyCopy' | translate }}
                            </mat-checkbox>
                          </div>
                        } @else {
                          <div fxFlex="80">
                            <mat-form-field class="campoFormulario">
                              <mat-label>{{ 'common.reportType.options.reviewBy.label' | translate
                              }}</mat-label>
                              <input type="text" [id]="'fullName'+indexSigner"
                                [name]="'fullName'+indexSigner" aria-label="text" matInput
                                [(ngModel)]="signer.fullName"[ngModelOptions]="{standalone: true}">
                            </mat-form-field>
                          </div>
                        }
                        <div fxFlex="10">
                          <button [id]="'delete'+indexSigner" [name]="'delete'+indexSigner" mat-icon-button
                            (click)="deleteSigner(indexSigner)" [disabled]="disabledSigned(signer)"
                            matTooltip="{{ 'button.delete' | translate }}">
                            <mat-icon>delete</mat-icon>
                          </button>
                        </div>
                      </div>
                      <div fxFLex="100" fxLayout="row">
                        <div [fxFlex]="data.isManual ? '80' :'100'">
                          <mat-form-field class="campoFormulario">
                            <mat-label>{{ 'common.reportType.options.role.label' | translate }}</mat-label>
                            <input matInput [id]="'role'+indexSigner" [(ngModel)]="signer.role"
                              [name]="'role'+indexSigner" [ngModelOptions]="{standalone: true}"
                              [disabled]="data.isManual ? false : (signer.internal || disabledSigned(signer))">
                          </mat-form-field>
                        </div>
                        @if (data.isManual) {
                          <div fxFLex="20">
                            <mat-form-field class="campoFormulario">
                              <mat-label>{{ 'signatureDocument.typeSigner.label' | translate }}</mat-label>
                              <mat-select [id]="'typeSignerSelect'+indexSigner" [name]="'typeSignerSelect'+indexSigner" [(ngModel)]="signer.typeSigner"
                                [disabled]="disabledSigned(signer)">
                                @for (item of typeSigners; track item) {
                                  <mat-option [id]="'typeSigner'+indexSigner" [name]="'typeSigner'+indexSigner" [value]="item.id">
                                    {{ 'signatureDocument.typeSigner.' + item.translation | translate }}
                                  </mat-option>
                                }
                              </mat-select>
                            </mat-form-field>
                          </div>
                        }
                      </div>
                      <div fxFLex="100" fxLayout="row">
                        <div fxFlex="70">
                          @if (!data.isManual) {
                            <mat-form-field class="campoFormulario">
                              <mat-label>{{ 'common.reportType.options.email.label' | translate }}</mat-label>
                              <input matInput [id]="'email'+indexSigner" [(ngModel)]="signer.email"
                                [name]="'email'+indexSigner" [ngModelOptions]="{standalone: true}"
                                [disabled]="signer.internal || disabledSigned(signer)">
                            </mat-form-field>
                          }
                        </div>
                        @if (!data.isManual && !signer.onlyCopy) {
                          <div fxFlex="30">
                            <mat-form-field class="campoFormulario">
                              <mat-label>{{ 'signatureDocument.typeSigner.label' | translate }}</mat-label>
                              <mat-select [id]="'typeSignerSelect'+indexSigner" [name]="'typeSignerSelect'+indexSigner" [(ngModel)]="signer.typeSigner"
                                [disabled]="disabledSigned(signer)">
                                @for (item of typeSigners; track item) {
                                  <mat-option [id]="'typeSigner'+indexSigner" [name]="'typeSigner'+indexSigner" [value]="item.id">
                                    {{ 'signatureDocument.typeSigner.' + item.translation | translate }}
                                  </mat-option>
                                }
                              </mat-select>
                            </mat-form-field>
                          </div>
                        }
                      </div>
                      @if (!data.isManual) {
                        @if (signer.signatureDate) {
                          <div fxFlex="100" style="color: green">
                            <span>{{'signatureDocument.signature.user' | translate}}</span>
                          </div>
                        }
                        @if (signer.signatureDate) {
                          <div fxFlex="100">
                            <span>{{'signatureDocument.signature.date' | translate}}: {{signer.signatureDate | fixDateTime}}</span>
                          </div>
                        }
                        @if (showReject(signer)) {
                          <div fxFlex="100">
                            <span>{{'signatureDocument.signature.reject.reason' | translate}}: {{signer.reasonRefuse}}</span>
                          </div>
                        }
                        @if (showReject(signer)) {
                          <div fxFlex="100">
                            <span>{{'signatureDocument.signature.reject.date' | translate}}: {{signer.modFc | fixDateTime}}</span>
                          </div>
                        }
                      }
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </div>
    </div>

    <br /><br />

    <div mat-dialog-actions class="qualificates-theme">
      <div fxFlex></div>
      @if (!inactiveSignature()) {
        <button mat-raised-button color="primary" (click)="prepareToSave()" cdkFocusInitial>{{ 'button.save' | translate
        }}</button>
        <div fxFlex="5px"></div>
      }
      @if (document?.id && !inactiveSignature()) {
        <button mat-raised-button color="primary" [disabled]="!disableSign()" (click)="deleteSigners()" cdkFocusInitial>{{
        'button.deleteSigner' | translate }}</button>
        <div fxFlex="5px"></div>
      }
      <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
    </div>
  </form>